/**
 * Copyright (c) 2023 Gitpod GmbH. All rights reserved.
 * Licensed under the GNU Affero General Public License (AGPL).
 * See License.AGPL.txt in the project root for license information.
 */

import { type FC, useEffect, useState, type PropsWithChildren } from "react";

type Props = PropsWithChildren<{
    wait?: number;
}>;
export const Delayed: FC<Props> = ({ wait = 1000, children }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => setShow(true), wait);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!show) {
        return null;
    }

    return <>{children}</>;
};
